import React, { useContext } from 'react'
import { Slide } from "react-slideshow-image";
import { Link } from "react-router-dom";
import { Button } from "antd";
import { IoIosArrowBack } from "react-icons/io";
import { Context } from "../../../Wrapper";

export default function Index() {
  const context = useContext(Context);

  const properties = {
    autoplay: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    indicators: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 0,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const divStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundSize: "cover",
    height: "25vh",
    borderRadius: 8,
    margin: 8
  };
  const slideImages = [
    {
      image: "./image/news2-1.jpg",
      caption: "Slide 1",
    },
    {
      image: "./image/news2-2.jpg",
      caption: "Slide 2",
    },
    {
      image: "./image/news2-3.jpg",
      caption: "Slide 2",
    },
    {
      image: "./image/news2-4.jpg",
      caption: "Slide 4",
    },
    {
      image: "./image/news2-5.jpg",
      caption: "Slide 5",
    },
    {
      image: "./image/news2-6.jpg",
      caption: "Slide 6",
    },
    {
      image: "./image/news2-7.jpg",
      caption: "Slide 7",
    },
    {
      image: "./image/news2-9.jpg",
      caption: "Slide 8",
    },
  ];

  return (
    <div style={{ padding: "36px 8%" }}>
      <div >
        <Link to="/#news" className='text-news'>
          <Button shape="circle" className='ant-btn-lang' >
            <IoIosArrowBack style={{ fontSize: 20, fontWeight: "bold", paddingRight: 2 }} />
          </Button>
        </Link>
      </div>

      {
        context.locale === "th-th" ?
          <div>
            <h1 className='h1-news' style={{ textAlign: 'center' }}>AS MaCharge เปิดตัว EV Bike ให้เช่าที่เกาะสมุย</h1>
            <h1 className='h1-news' style={{ textAlign: 'center' }}>พร้อมสถานีสับเปลี่ยนแบตเตอรี่ วางเป้าปีนี้ให้บริการ 200 คัน</h1>

            <div style={{ textAlign: 'center' }}>
              <img
                src="./image/news2.jpg"
                style={{ margin: "20px 0", width: "100%", maxWidth: 450, height: "auto", borderRadius: 8 }}
              ></img>
            </div>

            <div >
              <div className='text-news' style={{textIndent:"2.5em"}}>
                AS MaCharge ได้ฤกษ์เปิดตัว EV Bike ให้เช่า พร้อมสถานีสับเปลี่ยนแบตเตอรี่ ประเดิมให้บริการที่เกาะสมุย จังหวัดสุราษฎร์ธานี โดยมีผู้ถือหุ้น AMR ในสัดส่วน 60% และบริษัทในเครือ SUSCO ถือ 40% วางเป้าให้บริการ 200 คัน ก่อนปูพรมขยายตามจังหวัดท่องเที่ยวทั่วไทย
              </div>

              <div className='text-news' style={{textIndent:"2.5em"}}>
                นางสาวอัปสร ทางธนกุล กรรมการผู้จัดการ บริษัท เอเอส มาชาร์จ จำกัด (AS MaCharge) เปิดเผยว่า ในวันที่ 3 กรกฎาคม 2566 AS MaCharge ซึ่งเป็นบริษัทร่วมทุนระหว่าง AMR และบริษัท ซัสโก้ บียอนด์ จำกัด ในเครือซัสโก้ (SUSCO) ในสัดส่วน 60:40 ได้เปิดให้บริการเช่ารถจักรยานยนต์ไฟฟ้า พร้อมสถานีสับเปลี่ยนแบตเตอรี่ ที่เกาะสมุย จังหวัดสุราษฎร์ธานี โดยวางเป้าหมายให้บริการจำนวน 200 คัน ก่อนที่จะขยายไปตามจังหวัดที่มีนักท่องเที่ยวเป็นจำนวนมาก ทั้งนี้ SUSCO มีสถานีบริการน้ำมันอยู่จำนวน 4 แห่ง ที่มีศักยภาพ เป็นจุดให้บริการแก่ลูกค้า และ AS MaCharge ได้มีการหารือกับพันธมิตรอื่นเพิ่มเติม อาทิเช่น โรงแรม ร้านสะดวกซื้อ และร้านให้บริการเช่ารถจักรยานยนต์ในพื้นที่เกาะ รวมถึงการเข้าติดตั้งสถานีสับเปลี่ยนแบตเตอรี่ตามสถานที่ท่องเที่ยว และหน่วยงานภาครัฐ ให้บริการครอบคลุมพื้นที่เกาะสมุยโดยรอบไม่น้อยกว่า 10 สถานี เพื่อรองรับความต้องการลูกค้าทั้งชาวไทยและต่างชาติ
              </div>

              <div className='text-news' style={{textIndent:"2.5em"}}>
                “มั่นใจว่าให้เช่ารถจักรยานยนต์ไฟฟ้า ภายใต้แบรนด์ “E Bike UP” เป็นธุรกิจที่ตอบโจทย์การเดินทางและการท่องเที่ยวในพื้นที่เกาะ พร้อมกับตอกย้ำการส่งเสริมด้านการรักษาสิ่งแวดล้อม โดยเกาะสมุยถือเป็นพื้นที่ด้านการท่องเที่ยวที่มีศักยภาพเป็นที่รู้จักทั่วโลก ในทุกๆ ปีจะมีนักท่องเที่ยวทั้งชาวไทยและต่างประเทศแวะเวียนเข้ามาไม่ขาดสาย เชื่อว่าจะเป็นโอกาสทางธุรกิจที่สอดคล้องไปกับเมกะเทรนด์ของโลกยุคปัจจุบันและจะเติบโตอย่างต่อเนื่องในอนาคตอีกด้วย” นางสาวอัปสร กล่าว </div>
            </div>
            <div className='text-news' style={{textIndent:"2.5em"}}>
              ทั้งนี้ AS MaCharge มี "มาชาร์จ แพลตฟอร์ม" (MaCharge) สำหรับการใช้บริการเช่ารถจักรยานยนต์ไฟฟ้า การค้นหาสถานีสับเปลี่ยนแบตเตอรี่ รวมถึงสถานที่ท่องเที่ยวแนะนำบนเกาะสมุย ผ่านทาง http://samui.macharge.co โดยปัจจุบันมีบริการ E Bike Up จำนวน 40 คัน และตั้งเป้าการเพิ่มจำนวนให้บริการเช่ารถจักรยานยนต์ไฟฟ้าให้มากยิ่งขึ้น พร้อมกับการให้บริการสถานีสับแบตเตอรี่ MaCharge รอบเกาะสมุย ไม่น้อยกว่า 10 สถานี เพื่อความสะดวกสบายของลูกค้าที่ใช้บริการเช่ารถจักรยานยนต์ไฟฟ้า
            </div>
            <div>
              <Slide {...properties} >
                {slideImages.map((slideImage, index) => (
                  <div key={index}>
                    <div
                      style={{
                        ...divStyle,
                        backgroundImage: `url(${slideImage.image})`,
                      }}
                    >
                    </div>
                  </div>
                ))}
              </Slide>
            </div>


          </div>
          :
          <div>
            <h1 className='h1-news' style={{ textAlign: 'center' }}>AS MaCharge launches EV-Bike rental on Samui Island </h1>
            <h1 className='h1-news' style={{ textAlign: 'center' }}>with battery swapping stations expected to reach 200 e-bikes this year.</h1>

            <div style={{ textAlign: 'center' }}>
              <img
                src="./image/news2.jpg"
                style={{ margin: "20px 0", width: "100%", maxWidth: 450, height: "auto", borderRadius: 8 }}
              ></img>
            </div>

            <div className='text-news' style={{textIndent:"2.5em"}} >
              AS MaCharge has launched an EV Bike for rent with battery swapping stations, starting first service on Samui Island, Surat Thani Province. It is held by AMR holding 60% and SUSCO subsidiaries holding 40% and aims to provide 200 e-bikes before expanding to other tourist provinces across Thailand.
            </div>

            <div className='text-news' style={{textIndent:"2.5em"}}>
            Ms. Absorn Thangthanagul, Managing Director of AS MaCharge Co.,Ltd. (AS MaCharge), revealed that on July 3, 2023, AS MaCharge, a joint venture between AMR and Susco Beyond Company Limited, a subsidiary of SUSCO in the proportion of 60:40, has launched electric motorcycle rental services with battery swapping stations on Samui Island, Surat Thani Province. The goal is to provide 200 e-bikes before expanding to other provinces with a large number of tourists. Also, SUSCO has 4 gas stations located in the potential areas to be service points for customers. AS MaCharge has looked forward to discussing with additional partners such as hotels, convenience stores and motorcycle rental shops in the island area. Additional, there are more than 10 battery swapping stations located in tourist attractions and government agencies covering the surrounding area of Koh Samui to support the needs of both Thai and foreign customers. 
            </div>

            <div className='text-news' style={{textIndent:"2.5em"}}>
            “We are confident that electric motorcycle rental service under the brand ‘E-Bike UP’ is a business that meets the needs of tourists on the island along with reinforcing environmental protection. Samui Island is considered as tourism area that has the potential to be well-known around the world. Every year there is a constant flow of both Thai and foreign tourists stopping by. This will be a business opportunity that is in line with the current mega trends of the world and will continue to grow in the future”, Ms. Absorn said.
            </div>
            <div className='text-news'style={{textIndent:"2.5em"}}>
            AS MaCharge has “MaCharge platform" for using electric motorcycle rental services for finding a battery swapping stations and recommended tourist attractions on Samui Island via http://samui.macharge.co Currently, there are 40 e-bikes available and the goal is to increase the number of the rental services even more as well as the increase of MaCharge battery swapping stations around Samui Island with no less than 10 stations for the convenience of customers who use the rental service.
            </div>
            <div>
              <Slide {...properties} >
                {slideImages.map((slideImage, index) => (
                  <div key={index}>
                    <div
                      style={{
                        ...divStyle,
                        backgroundImage: `url(${slideImage.image})`,
                      }}
                    >
                    </div>
                  </div>
                ))}
              </Slide>
            </div>


          </div>



      }


    </div >
  )
}
